import { gql } from "@apollo/client";
import { ProductCardFieldsFragment } from "@govlaunch/product";
import { ProjectCardFieldsFragment } from "@govlaunch/project";
import CollectionGroupCardFieldsFragment from "~/src/components/collection/graphql/fragments/CollectionGroupCardFieldsFragment";

export default gql`
  query CollectionBySlug(
    $slug: String!
    $filterByItemType: CollectionItemType!
    $cursor: String
    $tags: [String!]!
    $countries: [String!]!
  ) {
    collectionBySlug(slug: $slug) {
      _id
      name
      status
      slug
      packaging
      viewerDidBookmark
      tags {
        _id
        name
        slug
        types
      }
      publicContentAvailable
      sponsoring
      sponsoringVendors {
        _id
        name
        slug
        logo
      }
      sponsoringProducts {
        _id
        name
        slug
        logo
      }
      createdAt
      updatedAt
      contentCounters(filterByTagSlugs: $tags, filterByCountry: $countries) {
        projectsCount
        groupsCount
        productsCount
        storiesCount
        governmentsCount
      }
      content(
        filterByItemType: $filterByItemType
        cursor: $cursor
        limit: 12
        filterByTagSlugs: $tags
        filterByCountry: $countries
      ) {
        items {
          ...ProjectCardFields
          ... on Story {
            _id
            title
            slug
            introduction
            createdAt
            modifiedAt
            lastPublishedAt
            hasPodcast
            medias {
              url
              type
            }
            storyGovernment: government {
              _id
              name
              logo
              city {
                _id
                country
              }
            }
            tags {
              _id
              slug
              name
            }
          }
          ... on Government {
            _id
            name
            logo
            slug
            city {
              _id
              governmentType
              country
              countryName
            }
          }
          ... on Product {
            ...ProductCardFields
          }
          ... on Group {
            ...CollectionGroupCardFields
          }
        }
        pageInfo {
          cursor
          hasNextPage
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
  ${ProductCardFieldsFragment}
  ${CollectionGroupCardFieldsFragment}
`;
